import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, isRef as _isRef, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
    class: "video w-full flex relative bg-black"
};
const _hoisted_2 = [
    "src"
];
import { ref, getCurrentInstance } from 'vue';
export default {
    __name: 'DialogVideo',
    setup (__props) {
        const { proxy } = getCurrentInstance();
        let dialogVisible = ref(false);
        let iframe = ref(null);
        proxy.$emitter.on('dialog_video', (data)=>{
            dialogVisible.value = true;
            iframe.value = data.iframe;
        });
        return (_ctx, _cache)=>{
            const _component_el_dialog = _resolveComponent("el-dialog");
            return _openBlock(), _createBlock(_component_el_dialog, {
                modelValue: _unref(dialogVisible),
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>_isRef(dialogVisible) ? dialogVisible.value = $event : dialogVisible = $event),
                width: "1000",
                "modal-class": "dailog-video",
                "destroy-on-close": true
            }, {
                default: _withCtx(()=>[
                        _createElementVNode("div", _hoisted_1, [
                            _cache[1] || (_cache[1] = _createElementVNode("div", {
                                style: {
                                    "padding": "56.25% 0 0 0",
                                    "position": "relative"
                                }
                            }, null, -1)),
                            _createElementVNode("iframe", {
                                src: _unref(iframe) + '?version=3&autoplay=1&controls=1&showinfo=0&modestbranding=1&loop=1&mute=0&rel=0&iv_load_policy=3&disablekb=1',
                                title: "YouTube video player",
                                frameborder: "0",
                                allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
                                referrerpolicy: "strict-origin-when-cross-origin",
                                allowfullscreen: "",
                                class: "w-full flex",
                                loading: "lazy"
                            }, null, 8, _hoisted_2)
                        ])
                    ]),
                _: 1
            }, 8, [
                "modelValue"
            ]);
        };
    }
};
